import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChange, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IAvailableTypes, IConstantItem } from 'src/app/core/models/available-types.interface';
import { UserService } from 'src/app/core/services/user.service';
import { IPaginatorProperties } from '../../../../../core/models/paginator.interface';
import { ICarrierItem, ISubService } from '../../../../shipment-price/models/shipment-price.interface';
import { ShipmentPriceService } from '../../../../shipment-price/services/shipment-price.service';
import { IOrderDetails } from '../../../models/order-details.model';
import { OrderType } from '../../../../../shared/enums/order-type.enum';
import { IAvailableCourierItem } from 'src/app/core/models/available-courier.interface';
import { IAgentInfo } from 'src/app/core/models/agent.interface';
import { AgentService } from 'src/app/core/services/agent.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { IPortItem } from '../../../models/ports.model';
import { PortsService } from '../../../services/ports.service';
import { ShipmentType } from 'src/app/shared/enums/shipment-type.enum';
import { ShipmentConsolStatus } from 'src/app/shared/enums/shipment-consol-status.enum';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { ICountry } from 'src/app/core/models/country.interface';
import { ConstantService } from 'src/app/core/services/constant.service';
import { IWarehouseInfo } from 'src/app/modules/customer-management/models/warehouse';
import { CustomerManagementService } from 'src/app/modules/customer-management/services/customer-management.service';
import { CarrierPopupComponent } from '../../../../carriers/components/carriers-list/carrier-popup/carrier-popup.component';
import { forkJoin, of } from 'rxjs';

export const consolidateShipmentDestinationCountries = ['NL', 'BE'];

@Component({
    selector: 'eci-consolidate-shipments-shipment-details',
    templateUrl: './consolidate-shipments-shipment-details.component.html',
    styleUrls: ['./consolidate-shipments-shipment-details.component.scss'],
    providers: [DatePipe]
})
export class ConsolidateShipmentsShipmentComponent implements OnInit {

    @Input() summaryPage = false;
    @Input() info: any;
    @Input() isCreateMode: boolean = true;
    @Input() availableTypes: IAvailableTypes;
    @Input() availableCarriers: ICarrierItem[] = [];
    @Input() availableFields: string[];
    @Input() hasError: boolean;
    @Input() actualDate: string;
    @Input() currentOrderType: number;
    @Input() availableCourier: IAvailableCourierItem[];
    @Input() availableAgents: IAgentInfo[];
    @Input() companyId: number;
    @Input() currShipmentType: number;
    @Input() showErrors: boolean;
    @Input() isOnlyUK: boolean;
    @Input() isEditable: boolean;

    @Output() infoChange = new EventEmitter<IOrderDetails>();
    @Output() hasErrorChange = new EventEmitter<boolean>();
    @Output() portDestinationChanged = new EventEmitter<string>();

    @Output() originPortsChange = new EventEmitter<any[]>();
    @Output() countriesChange = new EventEmitter<any[]>();
    @Output() destinationPortsChange = new EventEmitter<any[]>();

    @ViewChild(CdkVirtualScrollViewport, { static: false })
    cdkVirtualScrollViewPort: CdkVirtualScrollViewport;

    form: FormGroup;
    currencyOptions = ['EUR', 'USD', 'GBP'];
    minExpectedDate: Date;
    bookingDateLimit: Date;
    listOfOriginPorts: IPortItem[] = [];
    listOfDestinationPorts: IPortItem[] = [];
    previousePageOrigin: number = 0;
    previousePageDestination: number = 0;
    totalPagesOrigin: number = 1;
    totalPagesDestination: number = 1;
    showPorts: boolean = false;
    searchOrigin: string = '';
    searchDestination: string = '';

    searchCarrier1: FormControl = new FormControl('');
    searchCarrier2: FormControl = new FormControl('');
    searchocarrierServiceType: FormControl = new FormControl('');
    searchagentId: FormControl = new FormControl('');

    originPortFlag = false;
    destinationPortFlag = false;
    carrierListFlag = false;

    carrierSelectedRecord = [];
    destinationPortSelectedRecord = [];
    originPortSelectedRecord = [];
    /** Saved carrier id from API — re-applied after options load so mat-select can bind. */
    private savedCarrierId: number | null = null;

    originSearchEmpty = true;
    destinationSearchEmpty = true;

    allCountries: ICountry[];
    searchOriginCountry = new FormControl('');
    searchDestinationCountry = new FormControl('');
    destinationCountries: ICountry[];
    originCountries: ICountry[];
    shipmentPalletCarton: any;
    searchDestinationPorts = new FormControl('');

    searchsourceWarehouse: FormControl = new FormControl('');
    sourceWarehouses: IWarehouseInfo;

    clear_source_warehouse = false;
    private subServices: ISubService[] = [];
    private isCarrierDialogOpen = false;

    constructor(
        public userSvc: UserService,
        private formBuilder: FormBuilder,
        private datePipe: DatePipe,
        private agentSvc: AgentService,
        private portSvc: PortsService,
        private carriersSvc: ShipmentPriceService,
        private constSvc: ConstantService,
        private customerManSvc: CustomerManagementService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
    ) {
    }

    /** mat-select compare — avoids blank display when option id type differs from form value. */
    compareById = (a: any, b: any): boolean => {
        if (a == null && b == null) {
            return true;
        }
        if (a == null || b == null || a === '' || b === '') {
            return false;
        }
        return Number(a) === Number(b);
    };

    get availableCarriersList(): ICarrierItem[] {
        return [...(this.availableCarriers || [])];
    }

    /** Map shipment mode to carrier.mode filter (Inland uses Courier express carriers). */
    private getCarrierModeFilter(): number | undefined {
        const type = this.form?.get('carrierServiceType')?.value ?? this.currShipmentType;
        if (type === null || type === undefined || type === '') {
            return undefined;
        }
        return Number(type) === ShipmentType.Inland ? ShipmentType.CourierExpress : Number(type);
    }

    private sameShipmentMode(a: any, b: any): boolean {
        if (a == null && b == null) {
            return true;
        }
        if (a == null || b == null || a === '' || b === '') {
            return false;
        }
        return Number(a) === Number(b);
    }

    /**
     * mat-select often stays blank if the control value is set before options exist.
     * After the list is ready, put the selected carrier in options and re-bind the value.
     */
    private ensureSelectedCarrierOption(): void {
        // Prefer saved id — control may already be null if options loaded after setValue.
        const rawId = this.savedCarrierId ?? this.form?.get('carrierServiceProvider')?.value;
        if (rawId == null || rawId === '') {
            return;
        }
        const id = Number(rawId);
        if (!Number.isFinite(id)) {
            return;
        }

        const inList = (this.availableCarriers || []).some(c => Number(c?.id) === id);
        if (!inList) {
            const fromSelected = (this.carrierSelectedRecord || []).find(c => Number(c?.id) === id);
            if (fromSelected) {
                this.availableCarriers = [fromSelected, ...(this.availableCarriers || [])];
            } else {
                this.getSelectedCarrier(id, true);
                return;
            }
        }

        this.rebindCarrierFormValue(id);
    }

    /** Re-apply value after options render so mat-select matches an option. */
    private rebindCarrierFormValue(id: number): void {
        if (!this.form?.get('carrierServiceProvider')) {
            return;
        }
        this.savedCarrierId = id;
        // Defer until *ngFor options are in the DOM
        setTimeout(() => {
            const ctrl = this.form.get('carrierServiceProvider');
            if (!ctrl) {
                return;
            }
            // Toggle null → id forces mat-select to re-evaluate against current options
            ctrl.setValue(null, { emitEvent: false });
            ctrl.setValue(id, { emitEvent: false });
            this.cdr.detectChanges();
        });
    }

    get carrierType(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }

        return this.currentOrderType === OrderType.Domestic ? this.availableTypes.OrderShipmentType.filter(el => el.name !== 'Courier express' && el.name !== 'Ocean') : this.availableTypes.OrderShipmentType;
    }

    get isOcean(): boolean {
        return this.currShipmentType === ShipmentType.Ocean;
    }

    get isAir(): boolean {
        return this.currShipmentType === ShipmentType.Air;
    }

    get show0VatMessage(): boolean {
        if (!this.form) {
            return false;
        }
        return this.form.controls.destinationCountry.value === 'BE' || this.form.controls.destinationCountry.value === 'NL';
    }

    get isAdminUser(): boolean {
        return this.userSvc.isAdmin || this.userSvc.isShipmentsAdmin || this.userSvc.isDelegatedAdmin;
    }

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    get isDraft(): boolean {
        return Number(this.info?.status) === ShipmentConsolStatus.DRAFT;
    }

    get canEditAllDetails(): boolean {
        if (this.isCreateMode && !this.isEditable) {
            return true;
        }
        return this.isAdminUser || this.isDraft;
    }

    ngOnInit(): void {
        this.savedCarrierId = this.info?.shipment?.carrierId != null
            ? Number(this.info.shipment.carrierId)
            : null;

        this.form = this.initializeForm(this.info);
        this.loadWarehouses(1, 100, '', this.info.companyId);

        this.actualDate = this.info?.shipment?.actualTimeOfArrival;
        // Prefer form value (saved trackingType); do not force Air on create/edit.
        this.currShipmentType = this.form.get('carrierServiceType').value
            ?? (this.info?.shipment?.trackingType != null ? this.info.shipment.trackingType : undefined);

        // Load saved carrier first, then mode-filtered list, then re-bind form value (avoids blank mat-select).
        this.loadCarriersForCurrentMode();

        if (!this.isCreateMode) {
            this.getListOfDestinationPorts(1, this.info?.shipment?.destinationPort, 1000, this.info.type);
            this.getListOfOriginPorts(1, this.info?.shipment?.originPort, 1000, this.info.type);
        } else {
            this.getPorts();
        }

        this.constSvc.getAvailableCountries(1, 1000).subscribe(data => {
            if (data) {
                this.allCountries = data;
                this.filterOriginDestinationCountries();

                // if (!this.isOnlyUK) {
                //     this.destinationCountries = data.filter(el => !!consolidateShipmentDestinationCountries.includes(el.code));
                // } else {
                //     this.destinationCountries = data.filter(el => el.code === 'GB');
                // }
                this.countriesChange.emit(data);
            }
        });

        this.form.controls.originCountry.valueChanges.subscribe(data => {
            this.getListOfOriginPorts(1, this.searchOrigin, 20, this.currentOrderType, data);
            this.form.controls.originPort.enable();
        });

        this.form.controls.destinationCountry.valueChanges.subscribe(data => {
            this.getListOfDestinationPorts(1, this.searchDestination, 20, this.currentOrderType, data);
            this.form.controls.destinationPort.enable();
        });

        this.form.get('carrierServiceType').valueChanges.pipe(
            distinctUntilChanged((a, b) => this.sameShipmentMode(a, b)),
        ).subscribe(value => {
            const previousMode = this.currShipmentType;
            this.currShipmentType = value;
            this.previousCarriersPage = 0;
            this.carrierListFlag = false;

            // Clear carrier only when the user actually changes mode (ignore 2 vs "2").
            if (!this.sameShipmentMode(previousMode, value) && previousMode != null) {
                this.form.get('carrierServiceProvider').setValue(null, { emitEvent: false });
                this.carrierSelectedRecord = [];
                this.availableCarriers = [];
                this.savedCarrierId = null;
            }

            this.loadCarriersForCurrentMode();
            if (this.currShipmentType === ShipmentType.Ocean || this.currShipmentType === ShipmentType.Air
                || Number(this.currShipmentType) === ShipmentType.Ocean
                || Number(this.currShipmentType) === ShipmentType.Air) {
                this.previousePageOrigin = 0;
                this.previousePageDestination = 0;
                this.form.get('originPort').setValidators([Validators.required]);
                this.form.get('destinationPort').setValidators([Validators.required]);
                this.currentOrderType = this.info?.type;
            }
            this.getPorts();

            if (this.isShowCouriers) {
                this.form.controls.carrierServiceProvider.setValidators(null);
                this.form.controls.courierName.setValidators(Validators.required);
            } else {
                this.form.controls.courierName.setValidators(null);
                this.form.controls.carrierServiceProvider.setValidators(Validators.required);
            }
            this.form.controls.carrierServiceProvider.updateValueAndValidity({ emitEvent: false });
            this.form.controls.courierName.updateValueAndValidity({ emitEvent: false });
        });

        this.form.get('searchOrigin').valueChanges.pipe(debounceTime(500)).subscribe(value => {
            if (value !== '') {
                this.searchOrigin = value;
                this.previousePageOrigin = 0;
                this.originSearchEmpty = false;
                this.getListOfOriginPorts();
            } else {
                this.originSearchEmpty = true;
                this.getListOfOriginPorts();
            }
        });

        this.form.get('searchDestination').valueChanges.pipe(debounceTime(500)).subscribe(value => {
            if (value !== '') {
                this.searchDestination = value;
                this.previousePageDestination = 0;
                this.destinationSearchEmpty = true;
                this.getListOfDestinationPorts();
            } else {
                this.destinationSearchEmpty = true;
                this.getListOfDestinationPorts();
            }
        });

        this.form.get('originPort').valueChanges.subscribe(value => {
            const countryCode = this.listOfOriginPorts.find(el => el.IATA === value || el.code === value);
            this.portDestinationChanged.emit(countryCode?.countryCode);
        });

        if (this.info?.shipment?.originPort) {
            setTimeout(() => {
                const countryCode = this.listOfOriginPorts.find(el => el.IATA === this.info?.shipment?.originPort || el.code === this.info?.shipment?.originPort);
                this.portDestinationChanged.emit(countryCode?.countryCode);
                console.log(countryCode?.countryCode);
            }, 2000);
        }

        if (!this.isCreateMode) {
            this.getAvailableAgents(this.info.companyId);

            if (this.info.shipment.trackingType === ShipmentType.Ocean || this.info.shipment.trackingType === ShipmentType.Air) {
                this.showPorts = true;
            }
        }

        this.searchCarrier1.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousCarriersPage = 0;
            this.getAvailableCarriers();
        });

        this.form.get('carrierServiceProvider').valueChanges.subscribe(carrierId => {
            // Ignore interim null from rebindCarrierFormValue (emitEvent: false normally),
            // but if a real user clear happens, keep savedCarrierId in sync.
            if (carrierId == null || carrierId === '') {
                if (this.savedCarrierId != null) {
                    // Likely mat-select clearing before options were ready — restore after list load
                    return;
                }
                this.carrierSelectedRecord = [];
                return;
            }
            const id = Number(carrierId);
            this.savedCarrierId = id;
            if (this.carrierSelectedRecord?.[0] && Number(this.carrierSelectedRecord[0].id) === id) {
                return;
            }
            const fromList = (this.availableCarriers || []).find(c => Number(c?.id) === id);
            if (fromList) {
                this.carrierSelectedRecord = [fromList];
            } else {
                this.getSelectedCarrier(id);
            }
        });

        this.form.valueChanges.subscribe(_ => {
            this.info = this.model;
            this.getFormValidationErrors();
            this.infoChange.emit(this.info);
            this.hasErrorChange.emit(!this.form.valid);
        });

        if (this.info) {
            this.hasErrorChange.emit(!this.form.valid);
            this.shipmentPalletCarton = this.info.shipment?.shipmentConsolPalletCarton;
        }

        this.userSvc.changeCustomerInConsolShipment.subscribe((value) => {
            if (value != null) {
                this.loadWarehouses(1, 100, '', value);
            }
        });

        if (this.info?.sourceWarehouseId) {
            this.clear_source_warehouse = true;
        }
        this.subscribeOnWMSChanged();
    }

    private loadCarriersForCurrentMode(): void {
        this.previousCarriersPage = 0;
        const savedId = this.savedCarrierId;

        const loadList = () => {
            this.getAvailableCarriers('', 1, 10000);
        };

        if (savedId != null) {
            this.carriersSvc.getCarriersById(savedId).subscribe({
                next: (data) => {
                    if (data) {
                        this.carrierSelectedRecord = [data];
                        if (!(this.availableCarriers || []).some(c => Number(c?.id) === Number(data.id))) {
                            this.availableCarriers = [data, ...(this.availableCarriers || [])];
                        }
                    }
                    loadList();
                },
                error: () => loadList(),
            });
        } else {
            loadList();
        }
    }

    private getSelectedCarrier(id: number, rebindAfterLoad: boolean = false): void {
        const numId = Number(id);
        if (!Number.isFinite(numId)) {
            return;
        }
        this.carriersSvc.getCarriersById(numId)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.carrierSelectedRecord = [data];
                if (!(this.availableCarriers || []).some(c => Number(c?.id) === Number(data.id))) {
                    this.availableCarriers = [data, ...(this.availableCarriers || [])];
                }
                if (rebindAfterLoad || Number(this.form?.get('carrierServiceProvider')?.value) === Number(data.id)
                    || this.savedCarrierId === Number(data.id)) {
                    this.rebindCarrierFormValue(Number(data.id));
                }
            });
    }

    filterOriginDestinationCountries() {
        if (this.currentOrderType === OrderType.Domestic) {
            this.originCountries = this.allCountries?.filter(el => el.isEurope);
            this.destinationCountries = this.allCountries?.filter(el => el.isEurope);
        } else {
            this.originCountries = this.allCountries;
            this.destinationCountries = this.allCountries;
        }
    }

    subscribeOnWMSChanged(): void {
        this.form.get('sourceWarehouse').valueChanges.subscribe(() => {
            this.clear_source_warehouse = true;
        });
    }

    eventClearSourceSelection(): void {
        this.form.get('sourceWarehouse').setValue('');
        this.clear_source_warehouse = false;
    }

    getFormValidationErrors() {
        /*Object.keys(this.form.controls).forEach(key => {
          const controlErrors: ValidationErrors = this.form.get(key).errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
             console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
            });
          }
        });*/
    }

    private getPorts(): void {
        this.getListOfDestinationPorts();
        this.getListOfOriginPorts();
        this.showPorts = true;
    }

    ngOnChanges(changes: SimpleChange) {
        if (changes['actualDate'] && !!this.actualDate && this.form) {
            this.form.get('actualTimeOfArrival').setValue(new Date(this.actualDate) || '');
        }

        if (changes['companyId']) {
            this.companyId = changes['companyId'].currentValue;
            this.getAvailableAgents(this.companyId || this.userSvc.userStorage.company.id);
        }

        if (changes['currentOrderType']) {
            this.currentOrderType = Number(changes['currentOrderType'].currentValue);
            this.filterOriginDestinationCountries();
        }

        if (changes['showErrors']) {
            if (this.showErrors) {
                this.form?.markAllAsTouched();
            }
        }

        this.form?.get('originPort')?.valueChanges.subscribe(data => {
            this.listOfOriginPorts.map(item => {
                if (item.IATA === data || item.code === data) {
                    sessionStorage.setItem('city', item.name);
                }
            });
        });

    }

    loadWarehouses(
        page: number = 1,
        limit: number = 1000,
        q: string = '',
        companyId: number = this.info.companyId,
        orderField: string = '',
        orderDir: string = ''
    ): void {
        this.customerManSvc.getWareHouses(page, limit, q, companyId, orderField, orderDir).subscribe(data => {
            if (!data) return;
            this.sourceWarehouses = data as IWarehouseInfo;
        });
    }

    getAvailableAgents(companyId: number) {
        this.agentSvc.getAllAgents(1, 1000, '', companyId).subscribe(data => {
            this.availableAgents = data.items;
        });
    }

    initializeForm(info: any): FormGroup {
        return this.formBuilder.group({
            shipmentTerms: [''],
            courierName: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.slug }],
            carrierServiceType: [
                {
                    disabled: !this.canEditAllDetails,
                    // Prefer trackingType / carrier.mode (Air/Ocean/…); carrier.type is a label like "carrier".
                    value: info?.shipment?.trackingType != null
                        ? Number(info.shipment.trackingType)
                        : (info?.shipment?.carrier?.mode != null ? Number(info.shipment.carrier.mode) : null)
                }, [Validators.required]],
            carrierServiceProvider: [
                {
                    disabled: !this.canEditAllDetails,
                    value: info?.shipment?.carrierId != null ? Number(info.shipment.carrierId) : null
                }],
            agent: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.agent }],
            trackingNumber: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.trackingNumber }],
            expectedTimeOfArrival: [{
                disabled: !this.canEditAllDetails,
                value: new Date(info?.shipment?.expectedTimeOfArrival) || ''
            }, [Validators.required]],
            actualTimeOfArrival: [{ disabled: !this.canEditAllDetails, value: new Date(info?.shipment?.actualTimeOfArrival) || '' }],
            bookingDate: [{
                disabled: !this.canEditAllDetails,
                value: info?.shipment?.bookingDate ? new Date(info?.shipment?.bookingDate) : ''
            }, [Validators.required]],
            expectedTimeOfDeparture: [{
                disabled: !this.canEditAllDetails,
                value: new Date(info?.shipment?.expectedTimeOfDeparture) || ''
            }, [Validators.required]],
            originPort: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.originPort || null },],
            freightCost: [{
                disabled: !this.canEditAllDetails && !this.isAdminUser,
                value: info?.shipment?.freightCost || null
            }, [Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")]],
            currency: [{
                disabled: !this.canEditAllDetails && !this.isAdminUser,
                value: info?.shipment?.currency || 'EUR'
            }],
            destinationPort: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.destinationPort || null },],
            originCountry: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.originCountryCode }, [Validators.required]],
            destinationCountry: [{ disabled: !this.canEditAllDetails, value: info?.shipment?.destinationCountryCode }, [Validators.required]],
            searchOrigin: [''],
            searchDestination: [''],
            searchCourier: [''],
            sourceWarehouse: [{ disabled: !this.canEditAllDetails, value: info?.sourceWarehouseId }]
        });
    }

    get model(): any {
        return {
            ...this.info,
            sourceWarehouseId: parseInt(this.form.get('sourceWarehouse').value),
            shipment: {
                expectedTimeOfArrival: this.form.get('expectedTimeOfArrival').value != 'Invalid Date' ? this.datePipe.transform(this.form.get('expectedTimeOfArrival').value, 'yyyy-MM-dd') : '',
                bookingDate: this.form.get('bookingDate').value != 'Invalid Date' ? this.datePipe.transform(this.form.get('bookingDate').value, 'yyyy-MM-dd') : '',
                expectedTimeOfDeparture: this.form.get('expectedTimeOfDeparture').value != 'Invalid Date' ? this.datePipe.transform(this.form.get('expectedTimeOfDeparture').value, 'yyyy-MM-dd') : '',
                carrierId: this.form.get('carrierServiceProvider').value != null
                    && this.form.get('carrierServiceProvider').value !== ''
                    ? Number(this.form.get('carrierServiceProvider').value)
                    : null,
                // Do not send nested carrier relation — backend update can mis-apply carrier.id over carrierId.
                trackingType: this.form.get('carrierServiceType').value != null
                    && this.form.get('carrierServiceType').value !== ''
                    ? Number(this.form.get('carrierServiceType').value)
                    : null,
                agent: this.form.get('agent').value || null,
                originPort: this.form.get('originPort').value || null,
                freightCost: this.form.get('freightCost').value || null,
                currency: this.form.get('currency').value || 'EUR',
                destinationPort: this.form.get('destinationPort').value || null,
                originCountryCode: this.form.get('originCountry').value || null,
                destinationCountryCode: this.form.get('destinationCountry').value || null,
                trackingNumber: this.form.get('trackingNumber').value || null,
                shipmentConsolPalletCarton: this.shipmentPalletCarton,
                id: this.info?.shipment?.id || null,
            }
        };
    }

    isDatePickerValid(item: string): boolean {
        if (!item) {
            return;
        }
        const el = this.form.get(item);
        return el.value !== null;
    }

    onSelectOriginPort(value) {
        this.listOfOriginPorts.forEach((val: any) => {
            if ((val?.IATA && val.IATA == value) || (val?.code && val.code == value)) {
                this.originPortSelectedRecord = [val];
            }
        });
    }

    onSelectDetinationPort(value) {
        this.listOfDestinationPorts.forEach((val: any) => {
            if ((val?.IATA && val.IATA == value) || (val?.code && val.code == value)) {
                this.destinationPortSelectedRecord = [val];
            }
        });
    }

    onSelectCarrier(value) {
        const id = value != null && value !== '' ? Number(value) : null;
        this.savedCarrierId = id;
        if (id == null) {
            this.carrierSelectedRecord = [];
            return;
        }
        const fromList = (this.availableCarriers || []).find((val: any) => Number(val.id) === id);
        if (fromList) {
            this.carrierSelectedRecord = [fromList];
            return;
        }
        this.getSelectedCarrier(id);
    }

    openAddCarrierDialog(): void {
        if (this.isCarrierDialogOpen || !this.isAdmin || !this.canEditAllDetails) {
            return;
        }
        this.isCarrierDialogOpen = true;

        const subServices$ = this.subServices.length
            ? of(this.subServices)
            : this.carriersSvc.get<IPaginatorProperties<ISubService>>('sub-service', 1, 1000).pipe(
                map(data => data?.items || []),
            );

        const countries$ = (this.allCountries || []).length
            ? of(this.allCountries)
            : this.constSvc.getAvailableCountriesForScroll(1, 1000).pipe(
                map(data => data?.items || []),
            );

        forkJoin({ subServices: subServices$, countries: countries$ }).pipe(
            switchMap(({ subServices, countries }) => {
                this.subServices = subServices;
                if (!this.allCountries?.length) {
                    this.allCountries = countries;
                }

                const dialogRef = this.dialog.open(CarrierPopupComponent, { width: '900px' });
                dialogRef.componentInstance.countries = countries;
                dialogRef.componentInstance.subServices = subServices;
                dialogRef.componentInstance.createMode = true;
                dialogRef.componentInstance.info = {
                    mode: this.getCarrierModeFilter() ?? this.currShipmentType,
                } as any;

                return dialogRef.afterClosed();
            }),
        ).subscribe({
            next: (createdCarrier: ICarrierItem) => {
                this.isCarrierDialogOpen = false;
                if (!createdCarrier?.id) {
                    return;
                }
                const carrier = createdCarrier as ICarrierItem;
                this.carrierSelectedRecord = [carrier];
                const existingIds = new Set((this.availableCarriers || []).map(c => Number(c?.id)));
                if (!existingIds.has(Number(carrier.id))) {
                    this.availableCarriers = [carrier, ...(this.availableCarriers || [])];
                }
                this.savedCarrierId = Number(carrier.id);
                this.rebindCarrierFormValue(Number(carrier.id));
            },
            error: () => {
                this.isCarrierDialogOpen = false;
            },
        });
    }

    /*onOriginPorts(value): void {
      this.searchOrigin = value;
      this.previousePageOrigin = 0;
      this.getListOfOriginPorts();
    }*/

    /*onDetinationPorts(value): void {
      this.searchDestination = value;
      this.previousePageDestination = 0
      this.getListOfDestinationPorts();
    }*/

    getSlugById(id: any): string {
        if (!this.availableCarriersList) {
            return '';
        }
        const item = this.availableCarriersList.find(el => el.id === id);
        return item ? item.slug : '';
    }

    openChange($event: boolean) {
        if ($event) {
            this.cdkVirtualScrollViewPort.scrollToIndex(0);
            this.cdkVirtualScrollViewPort.checkViewportSize();
        } else {
        }
    }

    getListOfOriginPorts(
        page: number = this.previousePageOrigin + 1,
        q: string = !this.originSearchEmpty ? this.searchOrigin : '',
        limit: number = 20,
        orderType: number = OrderType.Import,
        countryCode: string = this.form.controls.originCountry.value
    ): void {
        switch (this.currShipmentType) {
            case ShipmentType.Ocean: {
                if (!countryCode) {
                    break;
                }
                this.portSvc.getOriginPorts(page, limit, q, orderType, countryCode).subscribe(data => {
                    if (!data) {
                        return;
                    }
                    this.setOriginPorts(data);
                });
            }
                ;
                break;
            case ShipmentType.Air: {
                if (!countryCode) {
                    break;
                }
                this.portSvc.getOriginAirports(page, limit, q, orderType, countryCode).subscribe(data => {
                    if (!data) {
                        return;
                    }
                    this.setOriginPorts(data);
                });
            }
                ;
                break;
        }
    }

    setOriginPorts(data): void {
        if (this.form.get('originCountry').value !== '') {
            if (data.meta.currentPage > 1) {
                this.listOfOriginPorts = [...this.listOfOriginPorts, ...data.items];
            } else {
                if (data.meta.itemCount >= 1) {
                    if (this.info?.shipment?.originPort && !this.originPortFlag) {
                        this.onEditGetOriginPorts(data.items);
                        this.originPortFlag = true;
                    } else {
                        this.listOfOriginPorts = [...this.originPortSelectedRecord, ...data.items];
                    }
                }
                else {
                    this.listOfOriginPorts = data.items;
                }
            }
            this.originPortsChange.emit(this.listOfOriginPorts);
            if (data.meta.itemCount >= 20) {
                this.previousePageOrigin = data.meta.currentPage;
            }
            this.totalPagesOrigin = data.meta.totalPages;
        }
    }


    onEditGetOriginPorts(selectedData) {
        switch (this.info.shipment.trackingType) {
            case ShipmentType.Ocean: {
                this.portSvc.getOriginPorts(1, 20, '', this.currShipmentType, this.form.controls.originCountry.value).subscribe(data => {
                    this.listOfOriginPorts = [...selectedData, ...data.items];
                });
            }
                ;
                break;
            case ShipmentType.Air: {
                this.portSvc.getOriginAirports(1, 20, '', this.currShipmentType).subscribe(data => {
                    this.listOfOriginPorts = [...selectedData, ...data.items];
                });
            }
                ;
                break;
        }
    }

    getListOfDestinationPorts(
        page: number = this.previousePageDestination + 1,
        q: string = !this.destinationSearchEmpty ? this.searchDestination : '',
        limit: number = 20,
        orderType: number = OrderType.Import,
        countryCode: string = this.form.controls.destinationCountry.value
    ): void {
        switch (this.currShipmentType) {
            case ShipmentType.Ocean: {
                if (!countryCode) {
                    break;
                }
                this.portSvc.getDestinationPorts(page, limit, q, orderType, null, false, countryCode).subscribe(data => {
                    if (!data) {
                        return;
                    }
                    this.setDestinationPorts(data);
                });
            }
                ;
                break;
            case ShipmentType.Air: {
                if (!countryCode) {
                    break;
                }
                this.portSvc.getDestinationAirports(page, limit, q, orderType, countryCode).subscribe(data => {
                    if (!data) {
                        return;
                    }
                    this.setDestinationPorts(data);
                });
            }
                ;
                break;
        }
    }

    setDestinationPorts(data): void {
        if (this.form.get('destinationCountry').value !== '') {
            if (data.meta.currentPage > 1) {
                this.listOfDestinationPorts = [...this.listOfDestinationPorts, ...data.items];
            } else {
                if (data.meta.itemCount >= 1) {
                    if (this.info?.shipment?.destinationPort && !this.destinationPortFlag) {
                        this.onEditGetDestinationPorts(data.items);
                        this.destinationPortFlag = true;
                    } else {
                        this.listOfDestinationPorts = [...this.destinationPortSelectedRecord, ...data.items];
                    }
                }
                else {
                    this.listOfDestinationPorts = data.items;
                }
            }
            this.destinationPortsChange.emit(this.listOfDestinationPorts);
            if (data.meta.itemCount >= 20) {
                this.previousePageDestination = data.meta.currentPage;
            }
            this.totalPagesDestination = data.meta.totalPages;
        }
    }

    onEditGetDestinationPorts(selectedData) {
        switch (this.currShipmentType) {
            case ShipmentType.Ocean: {
                this.portSvc.getDestinationPorts(1, 20, '', this.currShipmentType, null, false, this.form.controls.destinationCountry.value).subscribe(data => {
                    this.listOfDestinationPorts = [...selectedData, ...data.items];
                });
            }
                ;
                break;
            case ShipmentType.Air: {
                this.portSvc.getDestinationAirports(1, 20, '', this.currShipmentType).subscribe(data => {
                    if (!data) {
                        return;
                    }
                    this.listOfDestinationPorts = [...selectedData, ...data.items];
                });
            }
                ;
                break;
        }
    }

    get isShowCouriers(): boolean {
        return this.currShipmentType === ShipmentType.CourierExpress || this.currShipmentType === ShipmentType.Inland;
    }

    previousCarriersPage: number = 0;
    totalCarriersPage: number = 0;

    getAvailableCarriers(
        q: string = this.searchCarrier1.value,
        page: number = this.previousCarriersPage + 1,
        limit: number = 10000,
    ) {
        this.carriersSvc.get<IPaginatorProperties<ICarrierItem>>('carriers', page, limit, q).subscribe(data => {
            if (!data) {
                return;
            }

            if (data.meta.currentPage > 1) {
                const existingIds = new Set((this.availableCarriers || []).map(c => Number(c?.id)));
                this.availableCarriers = [
                    ...this.availableCarriers,
                    ...data.items.filter(item => !existingIds.has(Number(item.id))),
                ];
            } else {
                const formCarrierId = this.savedCarrierId ?? this.form?.get('carrierServiceProvider')?.value;
                const selected = (this.carrierSelectedRecord || []).filter(c =>
                    formCarrierId == null || formCarrierId === '' || Number(c?.id) === Number(formCarrierId)
                );
                const selectedIds = new Set(selected.map(c => Number(c?.id)));
                const rest = (data.items || []).filter(item => !selectedIds.has(Number(item.id)));
                this.availableCarriers = [...selected, ...rest];
            }
            this.previousCarriersPage = data.meta.currentPage;
            this.totalCarriersPage = data.meta.totalPages;
            this.ensureSelectedCarrierOption();
        });
    }

    onEditGetCarriersListPorts(selectedData) {
        this.carriersSvc.get<IPaginatorProperties<ICarrierItem>>('carriers', 1, 10000, '').subscribe(data => {
            const selected = this.carrierSelectedRecord?.length
                ? this.carrierSelectedRecord
                : (selectedData || []);
            const selectedIds = new Set(selected.map(c => Number(c?.id)));
            const rest = (data?.items || []).filter(item => !selectedIds.has(Number(item.id)));
            const fromPage = (selectedData || []).filter(item => !selectedIds.has(Number(item.id)));
            this.availableCarriers = [...selected, ...fromPage, ...rest];
            this.ensureSelectedCarrierOption();
        });
    }

    closedOriginPorts(): void {
        if (!this.form?.controls?.originPort?.value) {
            this.form?.controls?.searchOrigin?.setValue('');
        } else {
            this.form?.controls?.searchOrigin?.setValue(this.form?.controls?.originPort.value);
        }
    }

    closedDestinationPorts(): void {
        /*if (!this.form?.controls?.destinationPort?.value) {
          this.form?.controls?.searchDestination?.setValue('');
        } else {
          this.form?.controls?.searchDestination?.setValue(this.form?.controls?.destinationPort.value);
        }*/
    }

    closedCarriers(): void {
        if (!this.form?.controls?.carrierServiceProvider?.value) {
            this.searchCarrier1?.setValue('');
        } else {
            const name = this.availableCarriers.find(el => el.id === this.form?.controls?.carrierServiceProvider.value)?.name;
            this.searchCarrier1?.setValue(name);
        }
    }

    getFlagClass(code: any) {
        if (!code) return '';
        const c = this.allCountries?.find(c => c.id === code)?.code;
        return `iti__${c?.toLowerCase()}`;
    }
}
